<template>
    <div class="form-check">
            <input
            :name="name"
            class="form-check-input"
            type="checkbox"
            :id="`${model.status.formId}_${name}`"
            value="1"
            v-model="model.vals[name]"
            :disabled="model.status.disabled || disabled"
            >
            <label
            class="form-check-label"
            :for="`${model.status.formId}_${name}`"
            >{{label}}</label>
    </div>
</template>

<script>
export default {
    props:{
        name:String,
        label:String,
        model:Object,
        disabled:{
            type:Boolean,
            default:false,
        },
    }
}
</script>

<style>

</style>
